const slugify = (text: string | undefined): string => {
  if (!text) return ""

  return text
    .toLowerCase()
    .trim()
    .replace(/[\s_]+/g, '-')
    .replace(/[^\w-]+/g, '')
}

export default slugify

